(() => {
  const sectionSelector = '[data-article-faq-section]';
  const wrapperSelector = '.faqs-article-wrap';

  const animateAnswer = (answer, shouldOpen) => {
    answer.getAnimations().forEach((animation) => animation.cancel());

    const wasHidden = answer.hidden;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      answer.hidden = !shouldOpen;
      answer.style.display = shouldOpen ? 'block' : '';
      return;
    }

    if (shouldOpen) {
      answer.hidden = false;
      answer.style.display = 'block';
    }

    const startHeight = shouldOpen && wasHidden ? 0 : answer.getBoundingClientRect().height;
    const endHeight = shouldOpen ? answer.scrollHeight : 0;
    const answerMarginBottom = Number.parseFloat(window.getComputedStyle(answer).marginBottom) || 0;
    const startMarginBottom = shouldOpen && wasHidden ? 0 : answerMarginBottom;
    const endMarginBottom = shouldOpen ? answerMarginBottom : 0;

    answer.style.overflow = 'hidden';

    const animation = answer.animate(
      [
        {
          height: `${startHeight}px`,
          marginBottom: `${startMarginBottom}px`,
        },
        {
          height: `${endHeight}px`,
          marginBottom: `${endMarginBottom}px`,
        },
      ],
      {
        duration: 300,
        easing: 'ease',
      }
    );

    animation.onfinish = () => {
      answer.style.removeProperty('overflow');

      if (shouldOpen) {
        answer.style.display = 'block';
      } else {
        answer.hidden = true;
        answer.style.removeProperty('display');
      }
    };
  };

  const closeQuestion = (questionButton) => {
    const answer = questionButton.nextElementSibling;

    questionButton.classList.remove('active');
    questionButton.setAttribute('aria-expanded', 'false');

    if (answer && !answer.hidden) animateAnswer(answer, false);
  };

  const initializeWrapper = (faqWrapper, sectionElement, wrapperIndex) => {
    if (faqWrapper.dataset.accordionInitialized === 'true') return;

    const sourceNodes = Array.from(faqWrapper.childNodes);
    const hasQuestions = sourceNodes.some(
      (node) => node.nodeType === Node.ELEMENT_NODE && node.tagName === 'H3'
    );

    if (!hasQuestions) return;

    const sectionId = sectionElement.dataset.articleFaqSection;
    const iconTemplate = Array.from(document.querySelectorAll('[data-article-faq-icon-template]')).find(
      (template) => template.dataset.articleFaqIconTemplate === sectionId
    );

    if (!iconTemplate) return;

    faqWrapper.dataset.accordionInitialized = 'true';
    faqWrapper.classList.add('section-faq-wrp');

    const faqList = document.createElement('div');
    faqList.className = 'faq-wrap';

    const faqListItems = document.createElement('div');
    faqListItems.className = 'faq-list-items';
    faqList.appendChild(faqListItems);
    faqWrapper.appendChild(faqList);

    let currentAnswer = null;
    let questionIndex = 0;

    sourceNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'H3') {
        questionIndex += 1;

        const faqBox = document.createElement('div');
        faqBox.className = 'faq-box mt16';

        const faqContent = document.createElement('div');
        faqContent.className = 'faq-content';

        const questionButton = document.createElement('div');
        questionButton.className = 'faq-question mb16';
        questionButton.setAttribute('role', 'button');
        questionButton.setAttribute('tabindex', '0');
        questionButton.setAttribute('aria-expanded', 'false');

        const answerId = `ArticleFaqAnswer-${sectionElement.dataset.articleFaqSection}-${wrapperIndex}-${questionIndex}`;
        questionButton.setAttribute('aria-controls', answerId);

        node.classList.add('h5', 'm0');
        questionButton.appendChild(node);
        questionButton.appendChild(iconTemplate.content.cloneNode(true));

        const answer = document.createElement('div');
        answer.className = 'faq-answer h6 mt0 mb16 color-grey80';
        answer.id = answerId;
        answer.hidden = true;
        currentAnswer = answer;

        const toggleQuestion = () => {
          const shouldOpen = questionButton.getAttribute('aria-expanded') !== 'true';

          faqListItems.querySelectorAll('.faq-question.active').forEach((openQuestion) => {
            if (openQuestion !== questionButton) closeQuestion(openQuestion);
          });

          if (shouldOpen) {
            questionButton.classList.add('active');
            questionButton.setAttribute('aria-expanded', 'true');
            animateAnswer(answer, true);
          } else {
            closeQuestion(questionButton);
          }
        };

        questionButton.addEventListener('click', toggleQuestion);
        questionButton.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggleQuestion();
          }
        });

        faqContent.appendChild(questionButton);
        faqContent.appendChild(answer);
        faqBox.appendChild(faqContent);
        faqListItems.appendChild(faqBox);
      } else if (currentAnswer) {
        currentAnswer.appendChild(node);
      }
    });
  };

  const initializeAccordions = (root = document) => {
    const sections = [];

    if (root.matches?.(sectionSelector)) sections.push(root);
    root.querySelectorAll?.(sectionSelector).forEach((sectionElement) => sections.push(sectionElement));

    sections.forEach((sectionElement) => {
      sectionElement.querySelectorAll(wrapperSelector).forEach((faqWrapper, wrapperIndex) => {
        initializeWrapper(faqWrapper, sectionElement, wrapperIndex + 1);
      });
    });
  };

  const listenerFlag = 'articleFaqAccordionListenersAttached';

  if (document.documentElement.dataset[listenerFlag] !== 'true') {
    document.documentElement.dataset[listenerFlag] = 'true';

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAccordions(), { once: true });
    } else {
      initializeAccordions();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAccordions(event.target));
  } else {
    initializeAccordions();
  }
})();
